export default "__VITE_ASSET__COFRF3p6__"